import React,{useEffect,useRef} from 'react';
import {motion} from 'framer-motion';

const ParticleBackground=()=> {
  const canvasRef=useRef(null);

  useEffect(()=> {
    const canvas=canvasRef.current;
    const ctx=canvas.getContext('2d');
    let animationFrameId;

    const resizeCanvas=()=> {
      canvas.width=window.innerWidth;
      canvas.height=window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize',resizeCanvas);

    const particles=[];
    const particleCount=60; // Slightly more particles for tech feel

    class Particle {
      constructor() {
        this.x=Math.random() * canvas.width;
        this.y=Math.random() * canvas.height;
        this.vx=(Math.random() - 0.5) * 0.3; // Slower movement
        this.vy=(Math.random() - 0.5) * 0.3;
        this.size=Math.random() * 2 + 0.5;
        this.opacity=Math.random() * 0.5 + 0.1;
        // Tech colors: Blue / Cyan / Indigo
        this.color=Math.random() > 0.6 ? '#3b82f6' : (Math.random() > 0.5 ? '#10b981' : '#6366f1');
      }

      update() {
        this.x +=this.vx;
        this.y +=this.vy;

        if (this.x < 0 || this.x > canvas.width) this.vx *=-1;
        if (this.y < 0 || this.y > canvas.height) this.vy *=-1;
      }

      draw() {
        ctx.globalAlpha=this.opacity;
        ctx.fillStyle=this.color;
        ctx.beginPath();
        ctx.arc(this.x,this.y,this.size,0,Math.PI * 2);
        ctx.fill();
      }
    }

    // Initialize particles
    for (let i=0;i < particleCount;i++) {
      particles.push(new Particle());
    }

    const animate=()=> {
      ctx.clearRect(0,0,canvas.width,canvas.height);

      particles.forEach(particle=> {
        particle.update();
        particle.draw();
      });

      // Draw connections
      particles.forEach((particle,i)=> {
        particles.slice(i + 1).forEach(otherParticle=> {
          const dx=particle.x - otherParticle.x;
          const dy=particle.y - otherParticle.y;
          const distance=Math.sqrt(dx * dx + dy * dy);

          if (distance < 120) {
            ctx.globalAlpha=(120 - distance) / 120 * 0.15;
            ctx.strokeStyle='#3b82f6'; // Blue connections
            ctx.lineWidth=0.5;
            ctx.beginPath();
            ctx.moveTo(particle.x,particle.y);
            ctx.lineTo(otherParticle.x,otherParticle.y);
            ctx.stroke();
          }
        });
      });

      animationFrameId=requestAnimationFrame(animate);
    };

    animate();

    return ()=> {
      window.removeEventListener('resize',resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  },[]);

  return (
    <div className="fixed inset-0 z-0">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" style={{background: 'transparent'}} />
      
      {/* Updated background gradients for Tech theme */}
      <motion.div 
        className="absolute top-0 left-0 w-full h-full bg-slate-950 opacity-90"
      />
      
      <motion.div 
        className="absolute top-0 left-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[100px]"
        animate={{x: [-50,50,-50],y: [-50,50,-50],opacity: [0.1,0.2,0.1]}}
        transition={{duration: 15,repeat: Infinity,ease: "easeInOut"}}
      />
      
      <motion.div 
        className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-indigo-600/10 rounded-full blur-[120px]"
        animate={{x: [50,-50,50],y: [50,-50,50],opacity: [0.1,0.2,0.1]}}
        transition={{duration: 20,repeat: Infinity,ease: "easeInOut"}}
      />
    </div>
  );
};

export default ParticleBackground;